import React from 'react';
import { Card, CardBody, CardHeader, Col, Table } from 'reactstrap';
import { H5, Image } from '../../../AbstractElements';
import { UsageInBrowserTitle } from '../../../Constant';
import { UsageInBrowserTable } from '../../../Data/Widgets/general';

const UsageInBrowser = () => {
  return (
    <Col xl='6' md='6'>
      <Card className='browser-table'>
        <CardHeader className='pb-0'>
          <H5>{UsageInBrowserTitle}</H5>
        </CardHeader>
        <CardBody>
          <Table responsive className='table'>
            <thead>
              <tr>
                {UsageInBrowserTable.head.map((item, i) => (
                  <th key={i}>{item}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {UsageInBrowserTable.body.map((item) => (
                <tr key={item.id}>
                  <td>
                    <Image src={item.browser} alt={item.name} />
                  </td>
                  <td>{item.name}</td>
                  <td>{item.daily}%</td>
                  <td>{item.weekly}%</td>
                  <td>{item.monthly}%</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UsageInBrowser;
